import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-no-content',
    templateUrl: './no-content.component.html',
    standalone: false
})
export class NoContentComponent implements OnInit {
  @Input()
  displayText: string;

  constructor() {}

  ngOnInit() {}
}
